<div class="modal-header">
  <h6 class="modal-title d-flex align-items-center gap-2">
    <i class="cs-icon cs-icon-calendar-pause"></i>
    <ng-container *ngIf="isEdit" i18n>Edit Hold Event</ng-container>
    <ng-container *ngIf="!isEdit" i18n>Add Hold Event</ng-container>
    <app-page-help articleId="-" videoId="-"></app-page-help>
  </h6>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<ul class="nav top-navbar border-bottom bg-white">
  <li [class.active]="activeTab === tabs.Details">
    <a (click)="activeTab = tabs.Details" i18n> Details </a>
  </li>
  <li [class.active]="activeTab === tabs.Recurring">
    <a (click)="activeTab = tabs.Recurring" i18n> Recurring </a>
  </li>
  <ng-container *ngIf="isEdit">
    <li [class.active]="activeTab === tabs.Notes">
      <a (click)="activeTab = tabs.Notes" i18n> Comments </a>
    </li>

    <li [class.active]="activeTab === tabs.Logs">
      <a (click)="activeTab = tabs.Logs" i18n> Logs </a>
    </li>
  </ng-container>
</ul>
<div class="modal-body">
  <ng-container [ngSwitch]="activeTab">
    <ng-container *ngSwitchCase="tabs.Details">
      <app-hold-event-form [form]="form" [isEdit]="isEdit"></app-hold-event-form>
      <div class="mt-3">
        <ng-template [ngTemplateOutlet]="attachmentsTpl"></ng-template>
      </div>
    </ng-container>
    <ng-template *ngSwitchCase="tabs.Recurring" [ngTemplateOutlet]="recurringFormTpl"></ng-template>

    <app-comments-list *ngSwitchCase="tabs.Notes" entityType="hold_event" [entityId]="hold?.id">
      <app-empty-table type="CommentsList"></app-empty-table>
    </app-comments-list>

    <app-activity-table *ngSwitchCase="tabs.Logs" entityType="hold_event" [entityId]="hold?.id">
      <app-empty-table type="ActivityList"></app-empty-table>
    </app-activity-table>
  </ng-container>
</div>
<div class="modal-footer">
  <button
    (click)="delete()"
    type="button"
    class="btn btn-secondary-danger"
    [disabled]="1 | isReadonlyRole"
    *ngIf="isEdit && data.deletable"
  >
    <i class="cs-icon cs-icon-trash"></i> <ng-container i18n>delete</ng-container>
  </button>
  <div class="flex-fill"></div>
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button
    *ngIf="isEdit && data.convertable"
    matTooltip="Convert to booking"
    matTooltipPosition="above"
    i18n-matTooltip
    [disabled]="1 | isReadonlyRole"
    (click)="convert()"
    type="button"
    class="btn btn-secondary-info"
  >
    <i class="fal fa-bed"></i> <ng-container i18n>convert</ng-container>
  </button>
  <button
    (click)="onSave(form)"
    type="button"
    [disabled]="(1 | isReadonlyRole) || (isUpdating$ | async)"
    class="btn btn-secondary-info"
  >
    <i class="cs-icon cs-icon-save" *ngIf="!(isUpdating$ | async)"></i>
    <i class="far fa-spinner fa-spin" *ngIf="isUpdating$ | async"></i>
    <ng-container i18n>Save</ng-container>
  </button>
</div>

<ng-template #attachmentsTpl>
  <app-upload-box
    [options]="uploadBoxOptions"
    [showFileList]="false"
    (complete)="onUploadComplete($event)"
    *ngIf="attachments.length < 1"
  ></app-upload-box>
  <div *ngFor="let item of attachments; let i = index" class="d-flex align-items-center gap-3">
    <div class="text-primary text-xxl">
      <i class="" [ngClass]="item.name | fileIcon"></i>
    </div>
    <div class="mr-4 text-truncate">{{ item.name }}</div>
    <div class="flex-fill text-light text-right text-sm text-truncate">
      {{ item.created | epoch : 'DD-MMM-YYYY' }} at {{ item.created | epoch : 'HH:mm' }} • {{ item.user }} •
      {{ item.size | fileSize }}
    </div>
    <div class="d-flex align-items-center">
      <a href="javascript:;" class="btn btn-light-info btn-sm" (click)="onDownloadAttachment(item)"
        ><i class="cs-icon cs-icon-download"></i>
      </a>
      <a href="javascript:;" class="btn btn-light-danger btn-sm" (click)="onDeleteAttachment(item)"
        ><i class="cs-icon cs-icon-trash"></i>
      </a>
    </div>
  </div>
</ng-template>

<ng-template #recurringFormTpl>
  <app-recurring-form
    [form]="form.get('recurrenceRule')"
    [repeatableCtrl]="form.get('repeat')"
    [isUnlimitedEnabled]="false"
    class="d-block p-3"
  ></app-recurring-form>
</ng-template>
